import BaseState from "Engine/base/states/BaseState";
import EntryPoint from 'Engine/EntryPoint';

export default class WaitUserInteractionState extends BaseState {
    start() {
        super.start();
        if (EntryPoint.GameModel.isFreeSpinsMode) EntryPoint.GameModel.freespinsEnabled = true;
    }
}
